import { BaseService } from "./BaseService";

export const OnboardingIngresoColaboradorService = {
    async listarDetalleOnboardingIngreso(login, envioId, numeroDocumentoIdentidad) {
        const respuesta = await BaseService.get("/onboarding/colaborador/documentos", {
            params: {
                login: login,
                envioId: envioId,
                numeroDocumentoIdentidad: numeroDocumentoIdentidad,
            },
        });
        return respuesta.data;
    },

    async obtenerEstadoDocumento(params) {
        const respuesta = await BaseService.get("/onboarding/documentos/status", {
            params: {
                ...params,
            },
        });
        return respuesta.data;
    },

    async activarColaborador(data) {
        const respuesta = await BaseService.put("/onboarding/colaborador/activar", data);
        return respuesta.data;
    },

    async reenviarNotificacionOnboarding(numeroDocumentoIdentidad) {
        const respuesta = await BaseService.put(`/onboarding/colaborador/${numeroDocumentoIdentidad}/reenviar-notificacion-onboarding`);
        return respuesta.data;
    },

    async listarEnviosPorColaborador(params) {
        const respuesta = await BaseService.get("/onboarding/colaborador/envios", {
            params: {
                ...params,
            },
        });
        return respuesta.data;
    },

    async listarDocumentosFaltantesParaActivar(numeroDocumentoIdentidad) {
        const respuesta = await BaseService.get("/onboarding/colaborador/documentos-faltantes-activacion", {
            params: { numeroDocumentoIdentidad },
        });
        return respuesta.data;
    },

    async obtenerUltimoEnvioId(numeroDocumentoIdentidad) {
        const respuesta = await BaseService.get("/onboarding/colaborador/ultimo-envio", {
            params: { numeroDocumentoIdentidad },
        });
        return respuesta.data;
    },
};
